
import "./styles/common.less";
import { defineComponent } from "vue";
import HomePage from "./pages/home/index.vue";
import { mapActions } from "pinia";
import { useAppStore } from "./stores/app";

export default defineComponent({
  mounted() {
    this.onResize();
    window.addEventListener("resize", this.onResize);
    document.addEventListener("scroll", this.onScroll);
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.onResize);
    document.removeEventListener("scroll", this.onScroll);
  },
  methods: {
    onScroll() {
      this.setScrollTop();
    },
    onResize() {
      this.setWindowWidth();
    },
    ...mapActions(useAppStore, ["setWindowWidth", "setScrollTop"]),
  },
  render() {
    return <HomePage />;
  },
});
